<div class="container">
  <mat-toolbar>      
  <span>Buzones</span>
  <span class="sgd-spacer"></span>
  <button mat-flat-button class="btn-login" type="submit" (click)="onAdd()">Nuevo</button>
</mat-toolbar>    
 
 <div class="search-row">
  <mat-form-field appearance="outline" class="search-field">
    <mat-label>Buscar por departamento o cargo</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="Departamento o cargo" [value]="searchValue">
    @if (searchValue) {
      <button mat-icon-button matSuffix (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>
 
  <mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear matSortDirection="desc">
    
    <ng-container matColumnDef="departamento">
      <mat-header-cell *matHeaderCellDef>Departamento</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.departamento }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="cargo">
      <mat-header-cell *matHeaderCellDef>Cargo/nombre del buzón</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element">{{ element.cargo }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="op">
      <mat-header-cell *matHeaderCellDef class="acciones">&nbsp;</mat-header-cell>
      <mat-cell mat-cell *matCellDef="let element" class="acciones">
        <button mat-icon-button (click)="onEdit(element)">
          <mat-icon>edit</mat-icon>
        </button>        
        <button mat-icon-button (click)="onDelete(element)">
          <mat-icon>delete</mat-icon>
        </button>        
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns;sticky:false"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;">
    </mat-row>
    @if(!isLoadingResults){
    <div class="mat-row no-data-found" *matNoDataRow><app-no-data-found /></div>
    }

  </mat-table>
  @if(isLoadingResults){
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
  <mat-paginator #paginator [length]="resultsLength" pageSize="10" hidePageSize
    aria-label="P&aacute;gina selecci&oacute;n documentos en elaboraci&oacute;n">
  </mat-paginator>
</div>